import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Healthcare Partners', path: '/healthcare-partners' },
    { name: 'Procurement', path: '/procurement' },
    { name: 'Contact', path: '/contact' },
    { name: 'Careers', path: '/careers' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-28">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 py-3">
            <img 
              src="/logo.png" 
              alt="MoveraCare Mobility" 
              className="h-20 md:h-24 w-auto"
            />
            <div className="flex flex-col">
              <span className="text-2xl md:text-3xl font-bold text-[#004C97] leading-tight">
                MoveraCare
              </span>
              <span className="text-lg md:text-xl font-semibold text-[#F9A825] leading-tight">
                Mobility
              </span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isActive(item.path)
                    ? 'text-[#004C97] bg-[#004C97]/5'
                    : 'text-gray-700 hover:text-[#004C97] hover:bg-gray-50'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* CTA Buttons */}
          <div className="hidden lg:flex items-center space-x-4">
            <a href="tel:+18329252128" className="flex items-center space-x-2 text-[#004C97] hover:text-[#F9A825] transition-colors">
              <Phone className="w-4 h-4" />
              <span className="text-sm font-medium">(832) 925-2128</span>
            </a>
            <Link to="/book">
              <Button className="bg-[#F9A825] text-white hover:bg-[#E08E1E] font-semibold shadow-md hover:shadow-lg transition-all">
                Book a Ride
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden text-[#004C97] hover:text-[#F9A825] transition-colors"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200 shadow-lg">
          <nav className="px-4 py-4 space-y-2">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                onClick={() => setIsMenuOpen(false)}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  isActive(item.path)
                    ? 'text-[#004C97] bg-[#004C97]/5'
                    : 'text-gray-700 hover:text-[#004C97] hover:bg-gray-50'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <div className="pt-4 space-y-3 border-t border-gray-200">
              <a
                href="tel:+18329252128"
                className="flex items-center justify-center space-x-2 px-4 py-3 text-[#004C97] hover:text-[#F9A825] transition-colors"
              >
                <Phone className="w-4 h-4" />
                <span className="text-sm font-medium">(832) 925-2128</span>
              </a>
              <Link to="/book" onClick={() => setIsMenuOpen(false)}>
                <Button className="w-full bg-[#F9A825] text-white hover:bg-[#E08E1E] font-semibold shadow-md">
                  Book a Ride
                </Button>
              </Link>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
